import { createFileRoute } from "@tanstack/react-router";
import { MarketingShell } from "@/components/marketing-shell";
import { redirectIfAuthenticated } from "@/lib/marketing-guards";

export const Route = createFileRoute("/cookies")({
  beforeLoad: redirectIfAuthenticated,
  head: () => ({
    meta: [
      { title: "Cookie Policy, Super Affiliate OS" },
      {
        name: "description",
        content:
          "How Super Affiliate OS uses cookies and similar technologies, and how you can control them.",
      },
      { property: "og:title", content: "Cookie Policy, Super Affiliate OS" },
    ],
  }),
  component: CookiesPage,
});

function CookiesPage() {
  return (
    <MarketingShell>
      <article className="prose prose-invert mx-auto max-w-3xl px-6 py-20 prose-headings:tracking-tight prose-h1:text-4xl prose-h2:text-2xl prose-h2:mt-12 prose-h2:mb-3 prose-p:text-muted-foreground prose-li:text-muted-foreground prose-strong:text-foreground">
        <h1>Cookie Policy</h1>
        <p className="text-sm text-muted-foreground">Last updated: May 19, 2026</p>

        <p>
          We use a small number of cookies and similar technologies (like localStorage) to
          keep you signed in, remember preferences, and understand how the Service is used.
        </p>

        <h2>The cookies we use</h2>
        <ul>
          <li>
            <strong>Strictly necessary:</strong> authentication tokens and session state.
            Without these, you can't sign in or use the app. These can't be turned off.
          </li>
          <li>
            <strong>Functional:</strong> UI preferences like theme, sidebar state, and the
            last workspace you visited. Improve usability; not required.
          </li>
          <li>
            <strong>Analytics:</strong> aggregated, anonymized usage data so we can see which
            features are working and where users get stuck. No third-party advertising.
          </li>
        </ul>

        <h2>Managing cookies</h2>
        <p>
          You can clear cookies and localStorage at any time from your browser settings.
          Clearing strictly necessary cookies will sign you out. We don't use third-party
          advertising cookies and don't sell your browsing data.
        </p>

        <h2>Changes</h2>
        <p>
          We'll announce any material changes to this policy by email or in-app notice.
        </p>

        <h2>Contact</h2>
        <p>
          Questions? Email <strong>support@superaffiliateos.com</strong>.
        </p>
      </article>
    </MarketingShell>
  );
}
